export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-de8c194a',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
